import React from 'react';

const MODULES = [
    { free: true, title: 'Deal Management Platform', body: 'Initial application through to investment committee, one dashboard.' },
    { free: true, title: 'Application Triage', body: 'Structured fit report in 3–4 minutes, before you read a single deck.' },
    { free: true, title: 'Cohort Dashboard', body: 'Completion rates, risk flags, and certification, live across every company.' },
    { free: false, title: 'Existing Workflow Integration', body: 'Runs alongside Notion, Airtable, Salesforce, or your CRM via API.' },
];

const AccOperatorModulesSection = () => (
    <section className="lp-acc-sec lp-acc-sec--lavender" id="modules">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>The platform, module by module</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">Every module built for your programme.</h2>
            <p className="lp-acc-sub" data-lp-reveal data-lp-delay="120">Free for your programme, always. Everything you need to run deal flow from application to investment committee — with full visibility into every cohort company's readiness along the way.</p>

            <div className="lp-acc-modules" data-lp-reveal data-lp-delay="160">
                <div className="lp-acc-mod-legend">
                    <div className="lg-item"><span className="lg-swatch is-free" />Free</div>
                </div>
                <div className="lp-acc-mod-groups is-single">
                    <div className="lp-acc-mod-group is-white">
                        <div className="lp-acc-mod-group-head"><h3>For the Operator</h3></div>
                        <div className="lp-acc-mod-who">Every programme, at no cost</div>
                        <div className="lp-acc-mod-card-row">
                            {MODULES.map(m => (
                                <div className="lp-acc-mod-card" key={m.title}>
                                    {m.free && <span className="lp-acc-mod-tag is-free">Free</span>}
                                    <h4>{m.title}</h4>
                                    <p>{m.body}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default AccOperatorModulesSection;
